import React from "react";
import { Card, CardContent } from "@repo/ui";

interface Props {
  label: string;
  value: string | number;
  // Icon: any;
  fontClass?: string;
  onClick?: () => void;
}

export default function SlaKpiCard({
  label,
  value,
  // Icon,
  fontClass,
  onClick,
}: Props) {
  return (
    <Card
      onClick={onClick}
      className="bg-white shadow-md rounded-lg overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-200"
    >
      <CardContent className="p-6 flex flex-col justify-between h-full">
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-medium text-500">{label}</h3>
          {/* <Icon className="h-5 w-5 text-gray-400" /> */}
        </div>

        <div className={`mt-4 text-7xl text-center ${fontClass}`}>{value}</div>
      </CardContent>
    </Card>
  );
}
